<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 300px">Relatório de profissionais</legend>
      <div class="row">
        <div class="title-group">Atividade</div>
        <div class="group-itens">
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="todos" id="todos" v-model="form.todos" @click="todos" />
            <label class="form-check-label" for="todos"> Todos os profissionais </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="ativo" id="ativo" v-model="form.ativo" @click="desativaTodos" />
            <label class="form-check-label" for="ativo"> Ativos </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="inativo" id="inativo" v-model="form.inativo" @click="desativaTodos" />
            <label class="form-check-label" for="inativo"> Inativos </label>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="title-group">Tipo de profissional</div>
        <div class="group-itens">
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="MILITAR" id="MILITAR" v-model="form.militar" @click="desativaTodos" />
            <label class="form-check-label" for="MILITAR"> Militar </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="TERCEIRIZADO" id="TERCEIRIZADO" v-model="form.terceirizado" @click="desativaTodos" />
            <label class="form-check-label" for="TERCEIRIZADO"> Terceirizado </label>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchProfissional">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataProfissionais.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataProfissionais.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <a-table :dataSource="dataProfissionais" :columns="columns">
          <template #especialidade="{ record }">
            {{ record.especialidade.nome }}
          </template>
        </a-table>
      </div>
    </fieldset>

    <div id="iframe"></div>
  </div>
</template>

<script>
import { getProfRelatorio } from '@/components/service/profissionalService';
import { abrirImpressaoPorBlob, encaminharEmailTo } from '@/utils/servicos-utils';
import { gerarRelatorioHtmlProfissionais, gerarRelatorioProfissionais } from '@/components/service/gerarRelatorio';

export default {
  name: 'RelatorioProfissionais',
  data() {
    return {
      form: {
        todos: false,
        ativo: false,
        inativo: false,
        militar: false,
        terceirizado: false,
        pdf: undefined,
      },
      dataProfissionais: [],
      columns: [
        {
          title: 'Nome Completo',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Tipo',
          dataIndex: 'vinculo',
          key: 'vinculo',
        },
        {
          title: 'E-mail',
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: 'Telefone',
          dataIndex: 'telefoneCelular',
          key: 'telefoneCelular',
        },
        {
          title: 'Especialidade',
          dataIndex: 'especialidade',
          key: 'especialidade',
          slots: { customRender: 'especialidade' },
        },
      ],
    };
  },
  methods: {
    async searchProfissional() {
      await getProfRelatorio(this.form).then((r) => {
        this.dataProfissionais = r.data;
      });
    },
    todos() {
      this.form.ativo = false;
      this.form.inativo = false;
      this.form.militar = false;
      this.form.terceirizado = false;
    },
    desativaTodos() {
      this.form.todos = false;
    },
    async imprimirPDF() {
      if (this.dataProfissionais.length > 0) {
        await gerarRelatorioProfissionais({
          listaDadosDocumento: this.dataProfissionais,
          nomeDocumentoHtml: 'relatorio-profissionais.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dataProfissionais.length > 0) {
        await gerarRelatorioHtmlProfissionais({
          listaDadosDocumento: this.dataProfissionais,
          nomeDocumentoHtml: 'relatorio-profissionais.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Profissionais', r.data);
        });
      }
    },
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
